import { Injectable, signal } from '@angular/core';

/**
 * @class DynamicPageUiService
 * @description A lightweight, shared state service that tracks if a dynamic page is actively rendered
 * on the screen, and orchestrates the 3D flip state (Code View vs Page View) from the global application header.
 */
@Injectable({
  providedIn: 'root',
})
export class DynamicPageUiService {
  /** Signal indicating if a Dynamic Page is currently mounted in the router outlet. */
  public isDynamicPageActive = signal<boolean>(false);

  /** Signal controlling the 3D flip rotation (false = UI View, true = Code View). */
  public isCodeViewActive = signal<boolean>(false);
}
